/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_TitleInputs */

const en_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you need to ship`)
};

const zh_landing_features_title = /** @type {(inputs: Landing_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开箱即用的完整功能`)
};

/**
* | output |
* | --- |
* | "Everything you need to ship" |
*
* @param {Landing_Features_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_title = /** @type {((inputs?: Landing_Features_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_title(inputs)
	return zh_landing_features_title(inputs)
});
export { landing_features_title as "landing.features.title" }